import React from "react";
import {jsonLdScript, pageSchema} from "../../helper/schema";
import CommonStaticSidebar from "./commonStaticSidebar";
import API from "../../api";
import moment from "moment";
import Article from "../Common/article";
import FoodCard from "../Common/foodCard";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {images} from "../../constant";
import BestSellerGrid from "./bestSellerGrid";
import {Helmet} from "react-helmet";
import {BASE_URL, markNotFound} from "../../helper";
import NotFound from "./NotFound";
import CustomerReviews from "../Common/CustomerReviews";
const api = new API();

class SingleBlog extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            blog: null,
            default_store : this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
            scrollX: 0,
            scrolEnd: false,
            all_products: [],
        };
        this.scrl = React.createRef();
    }

    //Slide click
    slide = (shift) => {
        this.scrl.current.scrollLeft += shift;
        this.setState({scrollX: scrollX + shift});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    scrollCheck = () => {
        this.setState({scrollX: this.scrl.current.scrollLeft});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    // Server only: unknown blog slugs get a real 404. If the blog API fails we don't flag it (fail open).
    static async getInitialProps({req, res, match}) {
        if (req) {
            try {
                const blogs = await api.getSingleBlog(match.params.blog_slug);
                if (Array.isArray(blogs.data) && blogs.data.length === 0) {
                    markNotFound(res);
                    return {notFound: true};
                }
            } catch (e) {
                // ignore: treat as found
            }
        }
        return {};
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const slug = this.props.match.params.blog_slug ;
        api.getSingleBlog(slug).then(blogs => {
            this.setState({blog: blogs.data[0]});
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.blog_slug !== this.props.match.params.blog_slug ){
            const slug = this.props.match.params.blog_slug ;
            api.getSingleBlog(slug).then(blogs => {
                this.setState({blog: blogs.data[0]});
            });
        }
        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.default_store){
            this.setState({default_store: this.props.cookies.get('selected_store') });
        }
    }

    render() {
        if (this.props.notFound) {
            return <NotFound/>;
        }

        const category = this.state.blog?.["_embedded"]["wp:term"][0].map(u => u.name).join(' | ');
        const image = this.state.blog?.["_embedded"]["wp:featuredmedia"]?.[0]["media_details"]  ?  this.state.blog["_embedded"]?.["wp:featuredmedia"]?.[0]?.["media_details"]?.["sizes"]?.["medium"]?.["source_url"] : images.blog_place ;
        const author = this.state.blog?.["_embedded"]["author"][0]["name"];
        const sort_description = this.state.blog?.["acf"]["short_description"];
        const main_description = this.state.blog?.["content"]["rendered"];
        const button_text = this.state.blog?.["acf"]["button_text"];
        const button_link = this.state.blog?.["acf"]["button_link"];

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{this.state.blog?.title?.rendered}</title>
                        <meta name="description" content={sort_description}/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content={this.state.blog?.title?.rendered}/>
                        <meta property="og:description" content={sort_description}/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        {this.state.blog?.modified_gmt && <meta property="article:modified_time" content={this.state.blog.modified_gmt + "Z"}/>}
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        {jsonLdScript(pageSchema({
                            type: 'BlogPosting',
                            name: this.state.blog?.title?.rendered,
                            description: sort_description,
                            pathname: this.props.location.pathname,
                            extra: {
                                headline: this.state.blog?.title?.rendered,
                                datePublished: this.state.blog?.date_gmt ? this.state.blog.date_gmt + 'Z' : undefined,
                                dateModified: this.state.blog?.modified_gmt ? this.state.blog.modified_gmt + 'Z' : undefined,
                                author: {"@id": BASE_URL() + "/#organization"},
                                publisher: {"@id": BASE_URL() + "/#organization"}
                            }
                        }))}
                    </Helmet>
                    <div>
                        <div className="container-fluid about-content mt-3">
                            <div className="col-12">
                                <div className="row">
                                    <CommonStaticSidebar/>

                                   {this.state.blog && this.state.blog?.title &&
                                    <div className="col-md-9 emp-form">
                                        <div className="row">
                                            <div className="col-md-12 p-0">
                                                <div className="col-12 main-section bg-white p-4 text-left">
                                                    <div className="col-12 mb-md-4 mb-3 px-0">
                                                        <small className="text-muted text-uppercase font-weight-medium font-12">{category}</small>
                                                        <h1 className="my-2 art-head">{this.state.blog?.title?.rendered}</h1>
                                                        {/*<hr className="bg-theme opacity-100 m-0 mb-3"*/}
                                                        {/*    style={{width: "40px", height: "2px"}}/>*/}
                                                        {/*<h6 className="text-capitalize text-black mb-0">Written by {author}</h6>*/}
                                                        <h6 className="text-muted text-capitalize">Posted on: {this.state.blog?.date ? moment(this.state.blog?.date).format('LL') : ""}</h6>
                                                    </div>
                                                    {sort_description &&
                                                       <h6><p className="desc mb-0" dangerouslySetInnerHTML={{__html: sort_description}}/></h6>
                                                    }
                                                    <img alt={this.state.blog?.title?.rendered || "Blog post image"} className="img-fluid w-100 img-rounded" src={image} />
                                                    {button_link &&
                                                        <div className="col-12 text-center mb-2 px-0">
                                                            <a type="button" target="_blank" href={button_link}
                                                               className="btn btn-order py-2 px-4 mx-auto w-auto">{button_text}</a>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {main_description &&
                                                <div className="col-md-12 p-0">
                                                    <div className="col-12 blog-desc main-section bg-white p-4 text-left">
                                                        <div className="title mb-0 px-0">
                                                            <p className="desc mb-0"
                                                               dangerouslySetInnerHTML={{__html: main_description}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-12 text-center title pl-3 mb-3 mt-3">
                                                <h2 className="">Checkout Our Bestsellers</h2>
                                                <BestSellerGrid />
                                            </div>
                                        </div>
                                    </div>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <CustomerReviews tag="meat" limit={6}/>
                        </div>
                        <div className="col-12 article-related p-0">
                            <Article id={this.state.blog?.id}/>
                        </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default withCookies(SingleBlog);



